(function () {
  "use strict";

  var e = {
      d: function d(o, r) {
        for (var n in r) e.o(r, n) && !e.o(o, n) && Object.defineProperty(o, n, {
          enumerable: !0,
          get: r[n]
        });
      },
      o: function o(e, _o) {
        return Object.prototype.hasOwnProperty.call(e, _o);
      },
      r: function r(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }
    },
    o = {};
  e.r(o), e.d(o, {
    default: function _default() {
      return r;
    }
  });
  var r = function r(e) {
    var o = e.condition,
      r = e.show,
      n = e.elseShow,
      t = function t(e) {
        return "function" == typeof e;
      },
      u = function u(e) {
        return e() || (console.warn("Nothing was returned from your render function. Please make sure you are returning a valid React element."), null);
      };
    return o ? t(r) ? u(r) : r : !o && n ? t(n) ? u(n) : n : null;
  };
  module.exports = o;
})();